// Server timeout 30sec
export const apiTimeout = 30000;
